import React, { useEffect, useState } from "react";

/**
 * Manga-style speech bubble with typewriter effect cycling through phrases.
 */
export const SpeechBubble = ({ lines = [], speed = 45, holdMs = 1800, className = "" }) => {
  const [lineIdx, setLineIdx] = useState(0);
  const [text, setText] = useState("");
  const [phase, setPhase] = useState("typing"); // typing | holding | erasing

  useEffect(() => {
    const current = lines[lineIdx % lines.length] || "";
    let timer;

    if (phase === "typing") {
      if (text.length < current.length) {
        timer = setTimeout(() => setText(current.slice(0, text.length + 1)), speed);
      } else {
        timer = setTimeout(() => setPhase("holding"), holdMs);
      }
    } else if (phase === "holding") {
      timer = setTimeout(() => setPhase("erasing"), holdMs);
    } else if (phase === "erasing") {
      if (text.length > 0) {
        timer = setTimeout(() => setText(current.slice(0, text.length - 1)), speed / 2);
      } else {
        setLineIdx((i) => i + 1);
        setPhase("typing");
      }
    }
    return () => clearTimeout(timer);
  }, [text, phase, lineIdx, lines, speed, holdMs]);

  return (
    <div
      data-testid="hero-speech-bubble"
      className={`relative glass rounded-2xl px-5 py-4 md:px-6 md:py-5 max-w-sm ${className}`}
      style={{
        boxShadow:
          "0 0 0 1px rgba(0,229,255,0.35) inset, 0 12px 40px rgba(0,229,255,0.15)",
      }}
    >
      {/* tail */}
      <div
        className="absolute -bottom-3 left-8 w-6 h-6 rotate-45 glass"
        style={{ boxShadow: "0 0 0 1px rgba(0,229,255,0.35) inset" }}
        aria-hidden
      />
      <p className="font-mono-display text-sm md:text-base leading-relaxed text-white/90 min-h-[3.5rem]">
        <span className="text-[color:var(--primary)] mr-1">›</span>
        <span>{text}</span>
        <span className="caret text-[color:var(--accent)]">▌</span>
      </p>
    </div>
  );
};

export default SpeechBubble;